export default __webpack_public_path__ + "static/media/favicon-196x196.c7bae515.png";